import { render } from "./IconWakaba.vue?vue&type=template&id=7c002ef4"
import script from "./IconWakaba.vue?vue&type=script&lang=js"
export * from "./IconWakaba.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__